import { render, staticRenderFns } from "./SeparationAnxietyFAQCard.vue?vue&type=template&id=148cfcb4&scoped=true&"
import script from "./SeparationAnxietyFAQCard.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyFAQCard.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxietyFAQCard.vue?vue&type=style&index=0&id=148cfcb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148cfcb4",
  null
  
)

export default component.exports